import React from "react";
import UserModel from "../../../../model/UserModel";
import { PulseLoader } from "react-spinners";
import { Row, Col, Card } from "react-bootstrap";

export default class ContestsList extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			totalContest: 0, // Initializing totalContest state
			contestsList: [],
			page: 1,
			limit: 6,
			hasMore: true,
			loading: false,
		};

		this.userModel = new UserModel();
		this.scrollContainerRef = React.createRef(); // Reference to scroll div
		this.handleScroll = this.handleScroll.bind(this);
		this.fetchContestsList = this.fetchContestsList.bind(this);
	}

	componentDidMount() {
		this.fetchContestsList(); // Initial API call
		
	}

	componentWillUnmount() {
		const scrollContainer = this.scrollContainerRef.current;
		if (scrollContainer) {
			scrollContainer.removeEventListener("scroll", this.handleScroll);
		}
	}

	// Fetch contests list and update state
	async fetchContestsList() {
		const { page, limit } = this.state;
		
		this.setState({ loading: true });

		try {
			const resp = await this.userModel.GetContestsList(page, limit);
			const newContests = Array.isArray(resp.contestslist) ? resp.contestslist : [];
			
			this.setState((prevState) => ({
				totalContest: resp.total_contest || [], // Update totalContest from API response
				contestsList: [...prevState.contestsList, ...newContests],
				loading: false,
				page: prevState.page + 1,
				hasMore: newContests.length === limit, // Determine if there are more contests to fetch
			}));
			
		} catch (error) {
			console.error("Error fetching contests list:", error);
			this.setState({ loading: false });
		}
	}

	resetAndFetchContests() {
		this.setState({
			page: 1,
			contestsList: [],
			totalContest: 0,
			hasMore: true,
		}, () => {
			this.fetchContestsList();
		});
	}

	// Handle scroll event to fetch more contests when scrolled to bottom
	handleScroll() {
		const scrollContainer = this.scrollContainerRef.current;
		const { scrollTop, scrollHeight, clientHeight } = scrollContainer;
				
		if (!scrollContainer || this.state.loading || !this.state.hasMore) return;

		if (scrollTop + clientHeight >= scrollHeight - 100) {
			this.fetchContestsList();
		}
	}

	render() {
		const { loading, contestsList, totalContest } = this.state; // Destructure totalContest
		
		return (
			<div>
				{loading && totalContest.total_contest === 0 && (
					<PulseLoader
						loading={true}
						color="grey"
						aria-label="Loading Spinner"
						data-testid="loader"
					/>
				)}

				{/* Scrollable container */}
				<div
					ref={this.scrollContainerRef}
					onScroll={this.handleScroll} 
					className="contestlist"
				>
					<Row xs={1} md={2} lg={3} className="g-4">
						{totalContest.total_contest > 0 ? (
							contestsList.map((contest) => (
								<Col key={contest.contest_id}>
									<Card>
										<Card.Body>
											<img
												src={contest.image}
												alt={"No Image"}
												className="contestlistimage"
											/>
											<Card.Title>{contest.contest}</Card.Title>
											<Card.Text>
												<strong>Score:</strong> {contest.score}
											</Card.Text>
										</Card.Body>
									</Card>
								</Col>
							))
						) : (
							<h5 style={{ marginTop: "20px", paddingLeft: "15px" }}>
								You have not played any contest
							</h5>
						)}
					</Row>

					{loading && totalContest.total_contest > 0 && (
						<div style={{ textAlign: "center", padding: "10px" }}>
							<PulseLoader color="grey" />
						</div>
					)}
				</div>
			</div>
		);
	}
}
